import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if(req.url.indexOf(environment.urlApiRest) !== -1){
            var token = localStorage.getItem('token');
            const token_vide_intro = localStorage.getItem('token_video_intro');//1.- token de video intro
            localStorage.removeItem('token_video_intro');//2.- eliminamos el token de video intro para que solo se use una vez en la pagina

            if(token!="" && token!=null){//3.-validamos que exista el token de usuario
                if(token_vide_intro != "" && token_vide_intro != null){//4.-si existe un token de video el token sera igual al token de video, este solo se crea en player/compatibility
                    token = token_vide_intro;
                }

                const headers =  req.clone({
                    headers: req.headers.set('Authorization', token)
                });
                return next.handle(headers);
            }else if(token_vide_intro != "" && token_vide_intro != null){//3.1- validamos que exista el token de video
                const headers =  req.clone({
                    headers: req.headers.set('Authorization', token_vide_intro)
                });
                return next.handle(headers);
            }
        }
        
        return next.handle(req);
    }
}